

































































































import { Component, Emit, Model, Prop, Watch } from 'vue-property-decorator';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import Apps from '@/store/modules/Apps';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import AppsAddRenameDialog from '@/components/apps/AppsAddRenameDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue'
import Decision from '@/store/modules/Decisions';

const appModule = getModule(Apps);
const decisionModule = getModule(Decision);
@Component({
    components: {
        AppsAddRenameDialog,
        ConfirmationDialog
    },
})
export default class AppsAdditionalMenu extends Vue {
    private open = false;

    @Prop({ default: '', type: String })
    selectedAppId!: string;

    @Prop({default: false, type: Boolean})
    mainApp!: boolean;

    get decisionId(){
        return decisionModule.selectedDecisionId;
    }


    get appsDictionary() {
        return appModule.appsDictionary;
    }

    get selectedApp() {
        if (this.selectedAppId) {
            return this.appsDictionary[this.selectedAppId];
        } else {
            return null;
        }
    }
    mounted() {
        // this.internalValue = this.value;
        // this.internalDescription = this.description;
        // if (this.show) {
        //     setTimeout(() => (this.open = this.show), 200);
        // }
    }

    @Watch('open')
    onOpenChange(newVal: boolean, oldVal: boolean) {
        // if (!newVal && oldVal) {
        //     this.closedMenu();
        // } else if (newVal) {
        //     this.internalValue = this.value;
        //     this.internalDescription = this.description;
        //     this.$emit('open');
        // }
    }

    @Emit('closed')
    @Emit('save')
    @Emit('updated:text')
    private async save() {
        // console.log(this.decisionId);
        // const newApp = {
        //     name: this.internalValue,
        // };
        // const param = {
        //     decisionId: this.decisionId,
        //     app: newApp,
        // };
        // console.log(newApp);
        // await appModule.createApp(param);
        // this.open = false;
    }

    private confirmationTitle(){
        if(this.selectedApp){
            return "Confirm to Delete " + this.selectedApp.name;
        }else{
            return "Confirm to Delete";
        }
        
    }

    private async deleteApp(){
        await appModule.deleteApps({decisionId: this.decisionId, appId: this.selectedAppId}).then((res: any) =>{
            this.open = false;
        })
    }
    @Emit('cancel')
    private cancel() {
        // this.internalValue = this.value;
        // this.internalDescription = this.description;
        // this.open = false;
    }
    @Emit('change')
    @Emit('updated:text')
    private updateValue(newValue: string) {
        this.open = false;
        // return newValue;
    }

    @Emit('closed')
    private closedMenu() {
        // return this.internalValue;
    }
}
